/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const UPDATE_VIRTUAL_COMPONENT = gql`
    mutation updateVirtualComponent($input: UpdateVirtualComponentInput) {
        updateVirtualComponent(input: $input) {
            updated {
                id
                name
                description
                assigneeType
                virtualComponentLead {
                    jiraUserAccountId
                    jiraUserDisplayName
                    jiraUserAvatarUrl
                }
                projects {
                    id
                    jiraProjectId
                    jiraProjectKey
                    jiraProjectName
                    jiraComponentId
                    jiraAvatarUrls {
                        xsmall
                        large
                    }
                }
                virtualLabels {
                    id
                    name
                }
                parents {
                    id
                    name
                }
                parentId
            }
            loopParents {
                id
                name
            }
        }
    }
`;

export const UPDATE_MULTIPLE_VIRTUAL_COMPONENTS = gql`
    mutation updateVirtualComponents($input: [UpdateVirtualComponentInput]) {
        updateVirtualComponents(input: $input) {
            id
            name
            description
            assigneeType
            virtualComponentLead {
                jiraUserAccountId
                jiraUserDisplayName
                jiraUserAvatarUrl
            }
            projects {
                id
                jiraProjectId
                jiraProjectKey
                jiraProjectName
                jiraComponentId
                jiraAvatarUrls {
                    xsmall
                    large
                }
            }
            virtualLabels {
                id
                name
            }
            parentId
        }
    }
`;

export const CREATE_VIRTUAL_COMPONENT = gql`
    mutation createVirtualComponent($input: CreateVirtualComponentInput) {
        createVirtualComponent(input: $input) {
            id
            name
            description
            assigneeType
            virtualComponentLead {
                jiraUserAccountId
                jiraUserDisplayName
                jiraUserAvatarUrl
            }
            projects {
                id
                jiraProjectId
                jiraProjectKey
                jiraProjectName
                jiraComponentId
                jiraAvatarUrls {
                    xsmall
                    large
                }
            }
            virtualLabels {
                id
            }
            parentId
        }
    }
`;

export const CREATE_VIRTUAL_COMPONENT_RELEASE = gql`
    mutation createVirtualComponentRelease($input: CreateVirtualComponentReleaseInput) {
        createVirtualComponentRelease(input: $input) {
            success
            reasonCode
        }
    }
`;

export const UPDATE_VIRTUAL_COMPONENT_RELEASE = gql`
    mutation updateVirtualComponentRelease($input: UpdateVirtualComponentReleaseInput) {
        updateVirtualComponentRelease(input: $input) {
            success
            reasonCode
        }
    }
`;

export const DELETE_VIRTUAL_COMPONENT_RELEASE = gql`
    mutation deleteVirtualComponentRelease($id: String) {
        deleteVirtualComponentRelease(id: $id) {
            success
            reasonCode
        }
    }
`;

export const DELETE_VIRTUAL_COMPONENT = gql`
    mutation deleteVirtualComponent($id: String) {
        deleteVirtualComponent(id: $id) {
            success
        }
    }
`;

export const CREATE_VIRTUAL_COMPONENT_PROJECT = gql`
    mutation createVirtualComponentProject($input: CreateVirtualComponentProject) {
        createVirtualComponentProject(input: $input) {
            id
            jiraProjectId
            jiraProjectKey
            jiraProjectName
            jiraAvatarUrls {
                xsmall
                large
            }
        }
    }
`;

export const REMOVE_VIRTUAL_COMPONENT_PROJECT = gql`
    mutation createVirtualComponentProject($id: String) {
        removeVirtualComponentProject(id: $id)
    }
`;

export const JIRA_USERS_FOR_PICKER = gql`
    mutation jiraUsers($value: String) {
        jiraUsers(value: $value) {
            accountId
            displayName
            avatarUrl
        }
    }
`;

export const UPDATE_JIRA_ISSUE = gql`
    mutation updateJiraIssue($id: String, $body: UpdateJiraIssueInput) {
        updateJiraIssue(id: $id, body: $body) {
            id
        }
    }
`;

export const UPDATE_JIRA_ISSUE_VERSIONS = gql`
    mutation updateJiraIssueVersions($id: Int, $versions: [String]) {
        updateJiraIssueVersions(id: $id, versions: $versions) {
            success
        }
    }
`;

export const APP_INSTALL = gql`
    mutation synchronize {
        synchronize {
            success
        }
    }
`;

export const SYNCHRONIZE = gql`
    mutation synchronize {
        synchronize {
            success
        }
    }
`;

export const ACKNOWLEDGE_SYNC_ERRORS = gql`
    mutation acknowledgeSyncErrors($ids: [String]) {
        acknowledgeSyncErrors(ids: $ids) {
            success
        }
    }
`;

export const MERGE_VIRTUAL_COMPONENT = gql`
    mutation mergeVirtualComponent($parentComponentId: String, $targetComponentId: String) {
        merge(parentComponentId: $parentComponentId, targetComponentId: $targetComponentId) {
            success
            data
        }
    }
`;

export const SET_ACCESS_AUDIT = gql`
    mutation setAccessAudit {
        setAccessAudit {
            id
            type
        }
    }
`;

export const CREATE_VIRTUAL_LABEL = gql`
    mutation createVirtualLabel($input: CreateVirtualLabelInput) {
        createVirtualLabel(input: $input) {
            id
            name
        }
    }
`;

export const UPDATE_VIRTUAL_LABEL = gql`
    mutation updateVirtualLabel($input: UpdateVirtualLabelInput) {
        updateVirtualLabel(input: $input) {
            id
            parentId
        }
    }
`;

export const DELETE_VIRTUAL_LABEL = gql`
    mutation deleteVirtualLabel($id: String) {
        deleteVirtualLabel(id: $id) {
            success
        }
    }
`;

export const CREATE_JIRA_PROJECT_ID = gql`
    mutation createJiraProjectId($input: CreateJiraProjectIdInput) {
        createJiraProjectId(input: $input) {
            id
            project {
                id
                name
            }
            associateOption {
                id
                name
            }
        }
    }
`;

export const PROJECT_ENABLED_UPDATE = gql`
    mutation updateEnableProject($projectId: Int!, $isEnabled: Boolean!) {
        updateEnableProject(projectId: $projectId, isEnabled: $isEnabled) {
            status
        }
    }
`;
